import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MappingFormComponent } from './mapping-form/mapping-form.component';
import { BrandMappingManagementComponent } from './brand-mapping-management/brand-mapping-management.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: MappingFormComponent },
  { path: 'brand-management', component: BrandMappingManagementComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MappingRoutingModule {}
